import type { RunHud } from "../game/Game";
import type { Goal } from "../game/run";
import { GoalList } from "./GoalList";
import { PRIMARY, SECONDARY } from "./buttons";
import { KeyHint } from "./KeyHint";
import type { InputKind } from "./input-names";
import { DIALOG, SCRIM, TITLE } from "./theme";

/** The end of a 2-minute run: the score and the goals. X goes again, O back to free skate. */
export function RunResults({
  run,
  goals,
  mapName,
  onRetry,
  onFreeSkate,
  input = "keyboard",
}: {
  run: RunHud;
  goals: readonly Goal[];
  mapName: string;
  onRetry: () => void;
  onFreeSkate: () => void;
  /** The input you're using: its buttons are the ones named (#147). */
  input?: InputKind;
}) {
  return (
    <div className={`absolute inset-0 grid place-items-center ${SCRIM} p-4`}>
      <div
        role="dialog"
        aria-label="Run results"
        className={`${DIALOG} max-h-[calc(100dvh-2rem)] w-[min(90vw,28rem)] overflow-y-auto`}
      >
        <h2 className={`${TITLE} text-center text-3xl`}>Time's up!</h2>
        <p className="text-center text-sm font-bold uppercase tracking-widest opacity-70">{mapName}</p>
        <p className="my-3 text-center text-5xl font-black italic tabular-nums">{run.score.toLocaleString()}</p>
        <GoalList goals={goals} run />
        <div className="flex flex-col gap-2">
          <button
            type="button"
            autoFocus
            onClick={onRetry}
            className={`${PRIMARY} w-full px-4 py-2 text-lg`}
          >
            Run it again <KeyHint input={input} button="✕" />
          </button>
          <button
            type="button"
            onClick={onFreeSkate}
            className={`${SECONDARY} w-full px-4 py-2 text-lg`}
          >
            Free skate <KeyHint input={input} button="○" />
          </button>
        </div>
      </div>
    </div>
  );
}
